import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './RelatorioAdesaoAplicacao.css';
import { baixarArquivo } from "../../utils/downloadUtil";

import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }
const LIMITE_EXIBICAO_FINALIDADE = 500;
const RELATORIO_ADESAO_ORGAO = 'ORGAO';
const RELATORIO_ADESAO_APLICACAO_CONSUMIDORA = 'CONSUMIDORA';

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

registerLocale("pt_br", pt_br);

export const RelatorioAdesaoAplicacao =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				relatorio: RELATORIO_ADESAO_APLICACAO_CONSUMIDORA,
				orgaos: [],
				orgao: '',
				fornecedoras: [],
				fornecedora: '',
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				esferaAdministrativa: '',
				nomeConsumidora: "",
				periodoInicial: "",
				periodoFinal: "",
				ativo: true,
				comConsumo: "",
				carregandoFornecedoras: false,
				resultadoPesquisa: {},
				pesquisaExecutada : false,
				botoesHabilitados : true,
			};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.handleTipoRelatorioChange = this.handleTipoRelatorioChange.bind(this);
			this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarFornecedoras = this.carregarFornecedoras.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);
			this.toggleFinalidade = this.toggleFinalidade.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Relatório de Adesões</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();

			this.carregarOrgaos(this.state.esferaAdministrativa);
			this.carregarFornecedoras(this.state.orgao);

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const exibeBotoes = resultadoPesquisa.content && resultadoPesquisa.content.length > 0;
			const numberFormater = new Intl.NumberFormat('pt-BR', {useGrouping: true });

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-sm">
								<div className="field">
									<div className="input">
										<label>Tipo de Relatório:</label>
										<SelectSearch
											id="relatorio"
											name="relatorio"
											options={[{value: RELATORIO_ADESAO_APLICACAO_CONSUMIDORA, label: 'Adesões das Aplicações Consumidoras'},{value: RELATORIO_ADESAO_ORGAO, label: 'Adesões dos Órgãos'}]}
											onChange={this.handleTipoRelatorioChange}
											value={this.state.relatorio}
										/>
									</div>
								</div>
							</div>

							<div className="col-sd">
								<div className="field">
									<div className="input">
										<label>Esfera Administrativa:</label>
										<SelectSearch
											id="esferaAdministrativa"
											name="esferaAdministrativa"
											allOptionName="Todas"
											options={this.state.esferasAdministrativas.map(esfera => ({ value: esfera.codigo, label: esfera.nome }))}
											includeAllOption={true}
											onChange={this.handleEsferaAdministrativaChange}
											value={this.state.esferaAdministrativa}
										/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label >Órgao Consumidor:</label>
										<SelectSearch
											id="orgao"
											name="orgao"
											includeAllOption={true}
											options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
											onChange={this.handleOrgaoChange}
											value={this.state.orgao}
										/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{this.state.fornecedoras.length > 0 &&
											<SelectSearch
												id="fornecedora"
												name="fornecedora"
												includeAllOption={true}
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												onChange={this.handleInputChange}
												value={this.state.fornecedora}
											/>
										}
										{this.state.carregandoFornecedoras === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}

										{this.state.carregandoFornecedoras === false && this.state.fornecedoras.length === 0 && 'Não há APIs para serem selecionadas.'}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							{this.state.relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Nome Aplicação:</label>
											<input type="text" name="nomeConsumidora" 
												value={this.state.nomeConsumidora}  
												onChange={this.handleInputChange} 
												maxLength="15"/>
										</div>
									</div>
								</div>
							}

							{this.state.relatorio === RELATORIO_ADESAO_ORGAO &&
								<Fragment>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="periodoInicial">Período Inicial:</label>
												<DatePicker id="periodoInicial" locale="pt_br" dateFormat="dd/MM/yyyy" 
													selected={this.state.periodoInicial}
													onChange={data => {
														this.setState({periodoInicial: data});}
													} />
											</div>
										</div>
									</div>

									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="periodoFinal">Período Final:</label>
												<DatePicker id="periodoFinal" locale="pt_br" dateFormat="dd/MM/yyyy" 
													selected={this.state.periodoFinal}
													onChange={data => {
														this.setState({periodoFinal: data});}
													} />
											</div>
										</div>
									</div>
								</Fragment>
							}
							
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>{this.state.relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA ? 'Selecionar aplicações:' : 'Selecionar adesões'}</label>
										<SelectSearch
											id="ativo"
											name="ativo"
											includeAllOption={true}
											options={[{value: true, label: 'Ativas'},{value: false, label: 'Inativas'}]}
											onChange={this.handleInputChange}
											value={this.state.ativo}
										/>
									</div>
								</div>
							</div>

							{this.state.relatorio === RELATORIO_ADESAO_ORGAO &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Adesões(Consumo):</label>
											<SelectSearch
												id="comConsumo"
												name="comConsumo"
												includeAllOption={true}
												options={[{value: true, label: 'Com consumo'},{value: false, label: 'Sem consumo'}]}
												onChange={this.handleInputChange}
												value={this.state.comConsumo}
											/>

										</div>
									</div>
								</div>
							}
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

						{(content && content.length > 0) &&
							<div className="container-fluid">	
								<h2>Adesões:</h2>
								<div className="br-table">						
									<div className="table">
										<table>
											<thead>
												<tr>
													<th scope="col">Órgao</th>
													{this.state.relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA &&
														<th scope="col">Aplicação</th>
													}
													<th scope="col">{this.state.relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA ? 'Situação Aplicação' : 'Situação Adesão'}</th>
													<th scope="col">API</th>
													{this.state.relatorio === RELATORIO_ADESAO_ORGAO &&
														<Fragment>
															<th scope="col" className="text-right">Limite do Plano</th>
															<th scope="col" style={{width: "10%"}}>Data Início (Primeira Adesão)</th>
															<th scope="col" style={{width: "10%"}}>Data Alteração Volumetria ou Nova Adesao</th>
															<th scope="col">Data Fim</th>
														</Fragment>
													}
													<th style={{width: "30%"}} scope="col">Finalidade</th>
													<th style={{width: "4%"}} className="text-center" scope="col">Ações</th>
												</tr>
											</thead>
											<tbody>
												{ content.map((adesao, index) =>
														<tr key={index} >
															<td>{adesao.nomeOrgaoConsumidor}</td>
															{this.state.relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA &&
																<td>{adesao.nomeConsumidora}</td>
															}

															{this.state.relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA &&
																<td>{adesao.consumidoraAtiva ? "Ativa" : "Inativa"}</td>
															}

															{this.state.relatorio === RELATORIO_ADESAO_ORGAO &&
																<td>{adesao.adesaoAtiva ? "Ativa" : "Inativa"}</td>
															}

															<td>{adesao.nomeFornecedora}</td>
															{this.state.relatorio === RELATORIO_ADESAO_ORGAO &&
																<Fragment>
																	<td className="text-right">{numberFormater.format(adesao.limite)}/{adesao.periodicidade}</td>
																	<td>{adesao.dataPrimeiraAdesaoFornecedoraOrgaoConsumidor}</td>
																	<td>{adesao.dataInicio}</td>
																	<td>{adesao.dataFim}</td>
																</Fragment>
															}
															<td>{this.getFinalidade(adesao)}</td>
															<td className="text-center">
																<div className="actions">
																	{adesao.exibeExpandirComprimir === true &&
																		<button type="button" onClick={() => this.toggleFinalidade(index)} disabled={this.state.botoesHabilitados === false} title={adesao.mostraFinalidadeResumida ? "Expandir Finalidade" : "Comprimir Finalidade"}>
																			<span className="sr-only">Expandir/Comprimir Finalidade</span>
																			<i className={adesao.mostraFinalidadeResumida ? "fas fa-plus-square" : "fas fa-minus-square"}></i>
																		</button>
																	}
																</div>
															</td>
														</tr>
													)}
											</tbody>
										</table>
										<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
									</div>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Não foram encontrados dados para o filtro do relatório informado.
							</div>
						}

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		handleEsferaAdministrativaChange(evento){
			const esferaAdministrativa =  evento.target.value;
			const orgao = '';
			const fornecedora = '';

			this.setState({ esferaAdministrativa, orgao, fornecedora});

			this.carregarOrgaos(esferaAdministrativa);
		}

		handleOrgaoChange(evento){
			const idOrgao =  evento.target.value;

			this.setState({
				fornecedora: "",
				orgao: idOrgao,
			});

			this.carregarFornecedoras(idOrgao);
		}

		handleTipoRelatorioChange(evento){
			const relatorio =  evento.target.value;
			this.setState({
				relatorio,
				nomeConsumidora: "",
				periodoInicial: "",
				periodoFinal: "",
				comConsumo: "",
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			});
		}

		carregarOrgaos(esferaAdministrativa) {
			let url = '/api/orgao/consumidores/perfil-usuario';

			if (esferaAdministrativa) {
				url += `?esferaAdministrativa=${esferaAdministrativa}`;
			}

			api.get(url)
			.then(response => { this.setState({orgaos: response.data}) })
			.catch(erro => {
				console.log("Não foi possível recuperar órgãos consumidores " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});
		}

		carregarFornecedoras(idOrgao) {
			this.setState(
				{
					fornecedora: "",
					carregandoFornecedoras : true
				}
			);

			api.get(`/api/aplicacao-fornecedora/tipo-visao/C/orgao-consumidor?idOrgaoConsumidor=${idOrgao}`)
			.then(response => { 
				const fornecedoras = response.data;
				this.setState(
					{
						fornecedoras,
						carregandoFornecedoras : false,
					}
				)
			 })
			.catch(erro => {
				this.setState({carregandoFornecedoras : false});
				console.log("Não foi possível recuperar as aplicações fornecedoras " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada(pagina){
			const {fornecedora, esferaAdministrativa, orgao, nomeConsumidora, ativo, relatorio, periodoInicial, periodoFinal, comConsumo } = this.state;
			const criterioPesquisa = {fornecedora, esferaAdministrativa, orgao, nomeConsumidora, ativo, periodoInicial, periodoFinal, comConsumo };

			let url;
			if (relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA){
				url = '/api/aplicacao-consumidora/adesao/paginado';
			} else {
				url = '/api/orgao/adesao/paginado';
			}
			criterioPesquisa['pagina'] = pagina;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});
			api(options)
				.then(response => { 
					let resultadoPesquisa = response.data;

					for (const aac of resultadoPesquisa.content) { 
						const finalidade = aac.finalidade;
						const exibeExpandirComprimir = finalidade.length > LIMITE_EXIBICAO_FINALIDADE;
						aac['exibeExpandirComprimir'] = exibeExpandirComprimir;
						aac['mostraFinalidadeResumida'] = exibeExpandirComprimir;
					}

					this.setState({
						resultadoPesquisa,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as aplicações ", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		getFinalidade(adesaoAplicacaoConsumidora) {
			return adesaoAplicacaoConsumidora.mostraFinalidadeResumida ? adesaoAplicacaoConsumidora.finalidade.substring(0, LIMITE_EXIBICAO_FINALIDADE) + '...' : adesaoAplicacaoConsumidora.finalidade;
		}

		toggleFinalidade(index) {
			const resultadoPesquisa = this.state.resultadoPesquisa;
			const adesaoAplicacaoConsumidora = resultadoPesquisa.content[index];
			
			adesaoAplicacaoConsumidora['mostraFinalidadeResumida'] = ! adesaoAplicacaoConsumidora.mostraFinalidadeResumida;
			this.setState({resultadoPesquisa});
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const {fornecedora, esferaAdministrativa, orgao, nomeConsumidora, ativo, periodoInicial, periodoFinal, comConsumo, relatorio } = this.state;
			const criterioPesquisa = {fornecedora, esferaAdministrativa, orgao, nomeConsumidora, ativo, periodoInicial, periodoFinal, comConsumo };
			let url;
			if (relatorio === RELATORIO_ADESAO_APLICACAO_CONSUMIDORA){
				url = `/api/aplicacao-consumidora/adesao/${tipo}`;
			} else {
				url = `/api/orgao/adesao/${tipo}`;
			}

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioAdesoes.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de aplicação';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			const orgao = '';
			const esferaAdministrativa = '';
			this.setState({
				relatorio: RELATORIO_ADESAO_APLICACAO_CONSUMIDORA,
				esferaAdministrativa: '',
				orgaos: [],
				orgao,
				fornecedora: '',
				nomeConsumidora: "",
				ativo: true,
				periodoInicial: "",
				periodoFinal: "",
				comConsumo: "",
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
			this.carregarOrgaos(esferaAdministrativa);
			this.carregarFornecedoras(orgao);
		}

	}

) // redux
); // router